var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "div",
        { staticClass: "bg-white ", staticStyle: { height: "calc(100%)" } },
        [
          _c(
            "el-card",
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: { size: "small", model: _vm.detForm },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "", label: "项目编号：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.detForm.project.proCode)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "", label: "项目名称：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.detForm.project.name)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "", label: "项目单价：" } },
                            [
                              _c("span", [
                                _vm._v(
                                  "$ " +
                                    _vm._s(
                                      _vm.$mathUtil.mathToFixed(
                                        _vm.detForm.price
                                      )
                                    ) +
                                    " / " +
                                    _vm._s(_vm.detForm.unitEn)
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 2 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "ml4",
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.saveOrUpdateProject(_vm.detForm)
                                },
                              },
                            },
                            [_vm._v("配置项目信息")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "", label: "项目备注信息：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.detForm.description)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "项目图片：", prop: "" } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-row flex-w" },
                                _vm._l(
                                  _vm.detForm.picJsonList,
                                  function (item) {
                                    return _c("el-image", {
                                      key: item.id,
                                      staticStyle: {
                                        width: "100px",
                                        height: "100px",
                                        margin: "0 10px 10px 0",
                                      },
                                      attrs: {
                                        src: item.fileUrl,
                                        "preview-src-list": _vm.srcList,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "tableTitle" }, [_vm._v("已选材料：")]),
          _c(
            "div",
            { staticStyle: { "min-height": "calc(50% - 20px)" } },
            [
              _c(
                "vxe-table",
                {
                  ref: "cecUnmSetsTable",
                  attrs: {
                    border: "full",
                    "auto-resize": "",
                    resizable: "",
                    height: "auto",
                    loading: _vm.loading,
                    size: "small",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "highlight-hover-row": "",
                    "menu-config": {},
                    "print-config": {},
                    "import-config": {
                      importMethod: _vm.importMethod,
                      types: ["csv", "xls", "xlsx"],
                      remote: true,
                    },
                    "export-config": {
                      remote: true,
                      filename:
                        "套餐表数据" +
                        _vm.moment(new Date()).format("YYYY-MM-DD"),
                      sheetName: "套餐表数据",
                      exportMethod: _vm.exportMethod,
                      types: ["xlsx"],
                      modes: ["current", "selected", "all"],
                    },
                    "expand-config": {
                      accordion: true,
                      lazy: true,
                      loadMethod: _vm.loadContentMethod,
                    },
                    "sort-config": { remote: true },
                    data: _vm.dataList,
                    "checkbox-config": {},
                  },
                  on: { "sort-change": _vm.sortChangeHandle },
                },
                [
                  _c("vxe-column", {
                    attrs: {
                      field: "isMain",
                      width: "100",
                      align: "center",
                      title: "材料使用",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.mateKind))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      type: "expand",
                      width: "80",
                      align: "center",
                      title: "可选材料",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.itemSize > 0
                              ? _c("span", [_vm._v(_vm._s(row.itemSize))])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "content",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              { staticStyle: { padding: "10px" } },
                              [
                                _c(
                                  "vxe-table",
                                  {
                                    ref: "cecItemTable2",
                                    attrs: {
                                      border: "full",
                                      "auto-resize": "",
                                      resizable: "",
                                      loading: _vm.loadingch,
                                      size: "small",
                                      "show-header-overflow": "",
                                      "show-overflow": "",
                                      "highlight-hover-row": "",
                                      data: row.childData,
                                    },
                                  },
                                  [
                                    _c("vxe-column", {
                                      attrs: {
                                        type: "seq",
                                        align: "center",
                                        width: "50",
                                        title: "序号",
                                      },
                                    }),
                                    _c("vxe-column", {
                                      attrs: {
                                        field: "code",
                                        align: "center",
                                        width: "100",
                                        title: "物品编码",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm.hasPermission(
                                                  "cecitem:cecItem:view"
                                                )
                                                  ? _c(
                                                      "el-link",
                                                      {
                                                        attrs: {
                                                          type: "primary",
                                                          underline: false,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.view(
                                                              scope.row
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.code
                                                              ? scope.row.code
                                                              : ""
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.code
                                                            ? scope.row.code
                                                            : ""
                                                        )
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("vxe-column", {
                                      attrs: {
                                        field: "nameCn",
                                        align: "center",
                                        "show-overflow": "",
                                        title: "中文名称",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.nameCn
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content: scope.row
                                                            .nameCn
                                                            ? scope.row.nameCn
                                                            : "",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "textOverflow",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row.nameCn
                                                                  ? scope.row
                                                                      .nameCn
                                                                  : ""
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content: scope.row
                                                            .category
                                                            ? scope.row.category
                                                                .name
                                                            : "",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "textOverflow",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .category
                                                                  ? scope.row
                                                                      .category
                                                                      .name
                                                                  : ""
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("vxe-column", {
                                      attrs: {
                                        field: "name",
                                        align: "center",
                                        title: "英文名称",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.itemId
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content: scope.row
                                                            .name
                                                            ? scope.row.name
                                                            : "",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "textOverflow",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row.name
                                                                  ? scope.row
                                                                      .name
                                                                  : ""
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content: scope.row
                                                            .category
                                                            ? scope.row.category
                                                                .nameEn
                                                            : "",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "textOverflow",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .category
                                                                  ? scope.row
                                                                      .category
                                                                      .nameEn
                                                                  : ""
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("vxe-column", {
                                      attrs: {
                                        field: "category.name",
                                        align: "center",
                                        width: "100",
                                        sortable: "",
                                        title: "材料类别",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    staticClass: "item",
                                                    attrs: {
                                                      effect: "dark",
                                                      content: scope.row
                                                        .category
                                                        ? scope.row.category
                                                            .parentIdsName
                                                        : "",
                                                      placement: "top",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "textOverflow",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.category
                                                              ? scope.row
                                                                  .category.name
                                                              : ""
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("vxe-column", {
                                      attrs: {
                                        field: "price",
                                        align: "center",
                                        width: "100",
                                        sortable: "",
                                        title: "单价",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "flexBetween",
                                                  },
                                                  [
                                                    _c("span", [_vm._v("$")]),
                                                    scope.row.price
                                                      ? _c("div", [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row.price
                                                              ) + " / "
                                                            ),
                                                          ]),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row.units
                                                                  ? scope.row
                                                                      .units
                                                                      .unitEn
                                                                  : ""
                                                              )
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("vxe-column", {
                                      attrs: {
                                        field: "picture",
                                        width: "200",
                                        align: "center",
                                        title: "图片",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.picJsonList
                                                  ? _c("PopoverTipList", {
                                                      attrs: {
                                                        labelValue: "id",
                                                        tableType: "length",
                                                        tableHeight: "500px",
                                                        boxWidth: "200",
                                                        imageDisabled: true,
                                                        columns: [],
                                                        selectArray:
                                                          scope.row.picJsonList,
                                                      },
                                                    })
                                                  : _c("span", [_vm._v("-")]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("vxe-column", {
                                      attrs: {
                                        fixed: "right",
                                        align: "center",
                                        width: "250",
                                        title: "操作",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-row ai-center jc-center",
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticClass: "ml4",
                                                        attrs: {
                                                          type: "text",
                                                          size: "small",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.saveOrUpdateMaterialInfo(
                                                              scope.row
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("配置材料信息")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "code",
                      align: "center",
                      width: "100",
                      title: "物品编码",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.hasPermission("cecitem:cecItem:view")
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      underline: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.item
                                          ? scope.row.item.code
                                          : ""
                                      )
                                    ),
                                  ]
                                )
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.item ? scope.row.item.code : ""
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "nameCn",
                      align: "center",
                      "show-overflow": "",
                      title: "中文名称",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.itemId
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.item
                                        ? scope.row.item.nameCn
                                        : "",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "textOverflow" }, [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.item
                                            ? scope.row.item.nameCn
                                            : ""
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.category
                                        ? scope.row.category.name
                                        : "",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "textOverflow" }, [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.category
                                            ? scope.row.category.name
                                            : ""
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "name",
                      align: "center",
                      title: "英文名称",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.itemId
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.item
                                        ? scope.row.item.name
                                        : "",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "textOverflow" }, [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.item
                                            ? scope.row.item.name
                                            : ""
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.category
                                        ? scope.row.category.nameEn
                                        : "",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "textOverflow" }, [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.category
                                            ? scope.row.category.nameEn
                                            : ""
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "name",
                      align: "center",
                      width: "100",
                      title: "材料类别",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: scope.row.item
                                    ? scope.row.item.category.parentIdsName
                                    : "",
                                  placement: "top",
                                },
                              },
                              [
                                _c("div", { staticClass: "textOverflow" }, [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.item
                                        ? scope.row.item.category.name
                                        : ""
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "num",
                      align: "center",
                      width: "100",
                      title: "单价",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "flexBetween" }, [
                              _c("span", [_vm._v("$")]),
                              scope.row.item
                                ? _c("div", [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.price) + " / "),
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.item.units
                                            ? scope.row.item.units.unitEn
                                            : ""
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "rateNum",
                      width: "100",
                      align: "center",
                      title: "损耗率",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.rateNum) + "%"),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "rateDesc",
                      align: "center",
                      title: "损耗率描述",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "picture",
                      width: "200",
                      align: "center",
                      title: "图片",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.picJsonList.length > 0
                              ? _c("PopoverTipList", {
                                  attrs: {
                                    labelValue: "id",
                                    tableType: "length",
                                    tableHeight: "500px",
                                    boxWidth: "200",
                                    imageDisabled: true,
                                    columns: [],
                                    selectArray: scope.row.picJsonList,
                                  },
                                })
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      fixed: "right",
                      align: "center",
                      width: "250",
                      title: "操作",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex-row ai-center jc-center" },
                              [
                                scope.row.itemId
                                  ? _c(
                                      "div",
                                      [
                                        _c("GridSelect", {
                                          ref: "gridselectRef",
                                          attrs: {
                                            title: "配置可选材料",
                                            labelName: "nameCn",
                                            disabled: false,
                                            showPagination: false,
                                            showType: "none",
                                            labelValue: "id",
                                            value: scope.row.isItemSelectIds,
                                            limit: 50,
                                            columns: [
                                              {
                                                prop: "code",
                                                width: "80",
                                                label: "材料编号",
                                              },
                                              {
                                                prop: "nameCn",
                                                width: "100",
                                                label: "材料名称",
                                              },
                                              {
                                                prop: "image",
                                                width: "50",
                                                label: "图片",
                                              },
                                            ],
                                            searchs: [
                                              {
                                                prop: "code",
                                                label: "材料编号",
                                              },
                                              {
                                                prop: "nameCn",
                                                label: "材料名称",
                                              },
                                            ],
                                            dataListUrl:
                                              "/cecitem/cecItem/parentList",
                                            queryEntityUrl:
                                              "/cecitem/cecItem/queryById",
                                            params: {
                                              orders: [
                                                { column: "a.code", asc: true },
                                              ],
                                              parentId:
                                                scope.row.item.parentId == "0"
                                                  ? scope.row.item.id
                                                  : scope.row.item.parentId,
                                            },
                                          },
                                          on: {
                                            getValue: function ($event) {
                                              return _vm.updateItemSelectIds(
                                                $event,
                                                scope.row
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "ml4",
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveOrUpdateMaterialInfo(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("配置材料信息")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CecItemForm", {
        ref: "cecItemForm",
        on: { refreshDataList: _vm.refreshList },
      }),
      _c("CecUnmMaterialInfoByItemForm", {
        ref: "CecUnmMaterialInfoByItemFormRef",
        on: { refreshDataList: _vm.refreshList },
      }),
      _c("CecUnmProjectByItemForm", {
        ref: "CecUnmProjectByItemFormRef",
        on: { refreshDataList: _vm.getProjectDetail },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }